import React, { useRef, useEffect } from 'react';
import '../styles/Insta.css';

const InstaSection = () => {
  const ref = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const images = ref.current.querySelectorAll('.insta-img');
      const windowHeight = window.innerHeight;

      images.forEach(image => {
        const imageTop = image.getBoundingClientRect().top;

        if (imageTop < windowHeight * 0.9) {
          image.style.opacity = 1;  
          image.style.transform = 'translateY(0)'; 
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section ref={ref} className="Insta-section">
      {/* Background Image */}
      <div 
        className="Insta-bg" 
        style={{ 
          backgroundImage: 'url("background4.webp")', 
          backgroundSize: 'cover', 
          backgroundPosition: 'center' 
        }} 
      />

      {/* Foreground Overlay */}
      <div className="Insta-overlay"></div>
      
      <div className="Insta-container">
        <div className="Insta-heading">
          <h1>
            Instagram
            <a href='https://www.instagram.com/mahadevbookofficialin?igsh=MWZoa2ZyYzdlM3VueA=='>
              <img src="insta.webp" alt="Insta" className="insta" />
              Follow
            </a>
          </h1>
        </div>
        
        <div className="Insta-images">
        <a href={`https://wa.me/918949471009`}>
          <img 
            src="img1.webp" 
            alt="Insta" 
            className="insta-img" 
          /></a>
          <a href={`https://wa.me/918949471009`}>
          <img 
            src="img2.webp" 
            alt="Insta" 
            className="insta-img" 
          />
          </a>
          <a href={`https://wa.me/918949471009`}>
          <img 
            src="img3.webp" 
            alt="Insta" 
            className="insta-img" 
          />
          </a>
          <a href={`https://wa.me/918949471009`}>
          <img 
            src="img 4.webp" 
            alt="Insta" 
            className="insta-img" 
          />
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstaSection;
